// extracted by mini-css-extract-plugin
export default {"container":"Monitor1_container__F5MtI","rows":"Monitor1_rows__Vw7H7"};